/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("SlidingGallery", ["jquery", "Behaviors"], factory);
    } else {
        root.SlidingGallery = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    function SlidingGallery() {
        Behaviors.init(SlidingGallery, this, arguments);
        
        if( $(SlidingGallery.ELEMENTS.slickWrapper).length ){

            $(SlidingGallery.ELEMENTS.slickWrapper).slick( SlidingGallery.ELEMENTS.slickOptions );

            window.addEventListener('resize', slidingGalleryRefresh );
            window.addEventListener('load', slidingGalleryRefresh );

        }

        if( $(SlidingGallery.ELEMENTS.slickPopup).length ){
            $(SlidingGallery.ELEMENTS.slickPopup).slick( SlidingGallery.ELEMENTS.slickPopOptions );

            window.addEventListener('resize', slidingGalleryRefresh );
            window.addEventListener('load', slidingGalleryRefresh );
        }

    };

    var slidingGalleryRefresh = function(){
       
        var html = $(SlidingGallery.ELEMENTS.desktopNavContainer).html();

        if( html == '' ){
            html = $(SlidingGallery.ELEMENTS.mobileNavContainer).html()
        }

        if(window.innerWidth <= 768){
            $(SlidingGallery.ELEMENTS.desktopNavContainer).html('');
            $(SlidingGallery.ELEMENTS.mobileNavContainer).html(html);
        }else{  
            $(SlidingGallery.ELEMENTS.mobileNavContainer).html(''); 
            $(SlidingGallery.ELEMENTS.desktopNavContainer).html(html); 
        }
       
        $(SlidingGallery.ELEMENTS.slickWrapper).slick('refresh');

    };

    //Popup functions
    //Open popup on click
    $(".SlidingGallery_popup_item_click").click(function (e) {
        var $this = $(this);
        e.preventDefault();
        e.stopPropagation();
        $this.parents('.SlidingGallery').find('.slide-gallery-wrapper').addClass('SlidingGallery--popup-activate');
        var index = $this.data('image-i');
        $(SlidingGallery.ELEMENTS.slickPopup).slick('slickGoTo', index);
    });
    //Leave popup on click on popup it self
    $(".slider-popup-wrapper").click(function (e) {
        e.stopPropagation();
    });
    //Remove popup on popup item click
    $(".slider-popup-close").click(function () {
        var $this = $(this);
        $this.parents('.SlidingGallery').find('.slide-gallery-wrapper').removeClass('SlidingGallery--popup-activate');
    });
    //Remove popup on document/ body click
    $(document).on('click', function() {
        $('.slide-gallery-wrapper').removeClass('SlidingGallery--popup-activate');
    });

    Behaviors.inherit(SlidingGallery, Behaviors.Behavior);

    SlidingGallery.QUERY = "[data-sliding-gallery]";

    SlidingGallery.ELEMENTS = {
        slickWrapper: ".slide-gallery-wrapper .slide-items",
        desktopNavContainer: ".slide-navigation.desktop",
        mobileNavContainer: " .slide-navigation.mobile",
        slickPopup: ".slide-gallery-wrapper .slider-popup",
        slickOptions: {
            prevArrow: ".slide-prev",
            nextArrow: ".slide-next",
            autoplay: false
        },
        slickPopOptions: {
            dots: false,
            arrows: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow:"<div class='slick-arrow slick-prev pull-left'></div>",
            nextArrow:"<div class='slick-arrow slick-next pull-right'></div>",
            adaptiveHeight: true,
            autoplay: false,
        },
    };
            


    Behaviors.register_behavior(SlidingGallery);

    module.SlidingGallery = SlidingGallery;

    return module;
}));
